import ProjectAvatar from '../../../../vue_shared/components/project_avatar.vue?vue3';
import { OVERLAY_GOTO } from '../command_palette/constants';
import SearchResultFocusLayover from './global_search_focus_overlay.vue?vue3';
export default {
    name: 'FrequentlyVisitedItem',
    i18n: {
        OVERLAY_GOTO
    },
    components: {
        ProjectAvatar,
        SearchResultFocusLayover
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    }
};
